/* PageContainer — the frame of every secondary page, in the shell's language (13-15).
 * The page sits on the app bar's grid (--shell-max, --shell-gutter), so its title lines up with
 * the brand, as Today / Verify / Release do. The title is the mock's page head: serif, purple-dark
 * (identity), 40px. The size variants now set a reading measure for the content, left-aligned
 * on that grid, instead of centring a narrower column. */

.container {
  width: 100%;
  max-width: var(--shell-max);
  margin: 0 auto;
  padding: 0 var(--shell-gutter) 120px;
}

.container > * {
  max-width: var(--page-measure, none);
}

.sm {
  --page-measure: 640px;
}

.md {
  --page-measure: 820px;
}

.lg {
  --page-measure: none;
}

.full {
  --page-measure: none;
}

/* The page head (mock .pagehead h2). Each page's own .intro sits under it as the lede. */
.title {
  padding-top: 50px;
  margin: 0;
  font-family: var(--serif);
  font-weight: 400;
  font-size: clamp(32px, 4vw, 40px);
  line-height: 1.1;
  letter-spacing: -0.01em;
  color: var(--purple-dark);
}

/* A page without its own lede (the lodge form) still gets the head's bottom space. */
.title + :not(p) {
  margin-top: 28px;
}

@media (max-width: 720px) {
  .title {
    padding-top: 32px;
  }
}
